document.addEventListener('DOMContentLoaded', function() {
  // Initialize Masonry after page load
  const masonryGrid = document.querySelector('.masonry-grid');
  
  if (masonryGrid && typeof Masonry !== 'undefined') {
    new Masonry(masonryGrid, {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-item',
      percentPosition: true,
      gutter: 16,
      horizontalOrder: true
    });
  }

  // Reinitialize Masonry on window resize
  window.addEventListener('resize', function() {
    setTimeout(() => {
      if (typeof Masonry !== 'undefined') {
        const msnry = new Masonry(masonryGrid, {
          itemSelector: '.masonry-item',
          columnWidth: '.masonry-item',
          percentPosition: true,
          gutter: 16,
          horizontalOrder: true
        });
        msnry.layout();
      }
    }, 300);
  });

  // Handle dynamic content loading
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        setTimeout(() => {
          if (typeof Masonry !== 'undefined') {
            const msnry = new Masonry(masonryGrid, {
              itemSelector: '.masonry-item',
              columnWidth: '.masonry-item',
              percentPosition: true,
              gutter: 16,
              horizontalOrder: true
            });
            msnry.layout();
          }
        }, 500);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});